<template>
  <div class="input-spin-container w-100">
    <b-input
      class="w-100"
      :class="{ bypass: isInputDisabled }"
      type="number"
      :style="resolveInputMode"
      @input="onInputNumber"
      v-model="newValue"
    />
    <icon-spin-plus
      class="spin-plus"
      :class="maxValue == 0 || maxValue > newValue ? '' : 'spin-disabled'"
      :style="resolveSpinMode"
      @click.native="onSpin('plus')"
    />
    <icon-spin-minus
      class="spin-minus"
      :class="minValue == newValue  ? 'spin-disabled' : ''"
      :style="resolveSpinMode"
      @click.native="onSpin('minus')"
    />
  </div>
</template>

<script>
import IconSpinPlus from "@/@core/components/svg/input-spin/IconSpinPlus.vue";
import IconSpinMinus from "@/@core/components/svg/input-spin/IconSpinMinus.vue";
import {
  computed,
  onBeforeMount,
  ref,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
export default {
  props: {
    mode: { type: String, default: "add" },
    numValue: { type: Number, default: 0 },
    addValue: { type: Number, default: 0 },
    isInputDisabled: { type: Boolean, default: true },
    minValue: { type: Number, default: 0 },
    maxValue: { type: Number, default: 0 },
  },
  components: { IconSpinPlus, IconSpinMinus },
  setup(props) {
    const vm = getCurrentInstance().proxy;
    const MODE_ADD = "add";
    const MODE_REMOVE = "remove";
    const MODE_DISABLED = "disabled";

    const newValue = ref("0");

    const resolveSpinMode = computed(() => {
      switch (props.mode) {
        case MODE_ADD:
          return {
            fill: "#64a6ec",
            "pointer-events": "all",
          };
        case MODE_REMOVE:
          return {
            fill: "#AD0D00",
            "pointer-events": "all",
          };
        case MODE_DISABLED:
          return {
            fill: "#C4C4C4",
            "pointer-events": "none",
          };
        default:
          break;
      }
    });

    const resolveInputMode = computed(() => {
      switch (props.mode) {
        case MODE_ADD:
          return {
            "background-color": "#e3effc",
            border: "1px solid #7eb5ef",
          };
        case MODE_REMOVE:
          return {
            "background-color": "#FFEFEA",
            border: "1px solid #AD0D00",
          };
        case MODE_DISABLED:
          return {
            "background-color": "#E2E2E2",
            border: "1px solid #A9A9A9",
            "pointer-events": "none",
          };
        default:
          break;
      }
    });

    const onSpin = (spinType = "plus") => {
      if (props.addValue) {
        if (spinType == "plus") {
          newValue.value += props.addValue;
        } else {
          newValue.value -= props.addValue;
        }
      } else {
        if (spinType == "plus") {
          newValue.value++;
        } else {
          newValue.value--;
        }
      }

      if (newValue.value < 0) {
        newValue.value = 0;
        return;
      }
    };

    const onInputNumber = (e) => {
      let num = e.replace(/\D/g, "");
      setTimeout(() => {
        newValue.value = Number.parseInt(num);
      }, 1);   
    };

    watch(newValue, () => {
      vm.$emit("update-number", Number.parseInt(newValue.value));
    });

    watch(
      () => props.numValue,
      () => {
        newValue.value = props.numValue;
        if (props.numValue){
          if(props.maxValue){
            if(props.numValue > props.maxValue){
              newValue.value = props.maxValue;
            }
          }
        }
      }
    );

    onBeforeMount(() => {
      newValue.value = props.numValue;
    });

    return {
      newValue,
      resolveSpinMode,
      resolveInputMode,
      onSpin,
      onInputNumber,
    };
  },
};
</script>

<style scoped>
.input-spin-container {
  position: relative;
}

.input-spin-container > input {
  border-radius: 20px;
  background-color: #e3effc;
  border: 1px solid #7eb5ef;
  text-align: center;
  padding: 0 30px;
  height: 26px;
}

.input-spin-container .spin-plus {
  width: 20px;
  position: absolute;
  top: 3px;
  right: 3px;
  fill: #64a6ec;
  cursor: pointer;
}

.input-spin-container .spin-minus {
  width: 20px;
  position: absolute;
  top: 3px;
  left: 3px;
  fill: #64a6ec;
  pointer-events: all;
  cursor: pointer;
}

.input-spin-container .spin-disabled {
  fill: #C4C4C4 !important;
  pointer-events: none !important;
  cursor: none;
}
</style>
